import {createSelector} from "@reduxjs/toolkit";
import {State} from "types/store";

export const get = (rootState: State) => rootState.policy;

export const getTermsOfService = createSelector(get, (policyState) => policyState.terms_of_service);

export const getPrivacy = createSelector(get, (policyState) => policyState.privacy);
